<template>
  <div>
    <el-row style="text-align: center">
      <div style="font-size: 30px;margin-top: 20px">勘察单位注册</div>
    </el-row>
    <el-row>
      <hr
        size="1"
        style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 30px"
      />
    </el-row>
    <el-row style="text-align: left">
      <el-button type="text" icon="el-icon-arrow-left" @click="back"
        >返回登录页面</el-button
      >
    </el-row>
    <el-row type="flex" justify="center" style=" margin-top: 20px">
      <el-form
        label-width="200px"
        ref="registerRef"
        :model="register.data"
        :rules="register.rules"
        label-position="right"
        v-loading="register.loading"
        style="width: 50%"
      >
        <el-row>
          <el-col>
            <el-form-item label="单位名称:" prop="corpName">
              <el-input v-model="register.data.corpName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="营业执照|组织机构代码:"
              prop="organizationCode"
            >
              <el-input v-model="register.data.organizationCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col>
            <el-form-item label="营业执照|组织机构证书:">
              <el-upload
                class="upload-demo"
                :before-upload="beforeUpload"
                :on-error="uploadFail"
                :on-success="uploadSuccess"
                ref="upload"
                :action="url.upload"
                :auto-upload="false"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-form-item label="单位所在地:" prop="areainfos">
            <el-col>
              <el-cascader
                placeholder="选择城市"
                v-model="register.data.areainfos"
                :options="city"
                :props="props"
                filterable
                style="width: 100%"
                change-on-select
              ></el-cascader>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="单位详细地址:" prop="address">
              <el-input v-model="register.data.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="法人姓名:" prop="legalPerson">
              <el-input v-model="register.data.legalPerson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="联系人:" prop="contactPerson">
              <el-input v-model="register.data.contactPerson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="手机号码:" prop="contactPersonTel">
              <el-input
                v-model="register.data.contactPersonTel"
                :disabled="mon_count"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col>
            <el-form-item label="校验码:" prop="verification">
          <el-input
                type="verification"
                placeholder="校验码"
                v-model="register.verification"
                style="width:160px;float:left;height:30px;line-height:20px"
              ></el-input>
              <div
                class="code1"
                @click="refreshCode"
              >
                <identify :identifyCode="identifyCode"></identify>
              </div>
              </el-form-item>
              </el-col>
        </el-row>
        <el-row>
          <el-form-item label="验证码:" prop="verificationCode">
            <el-col :span="18">
              <el-input v-model="register.verificationCode"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :disabled="regverification || mon_count"
                @click="auth_code"
                >{{ mon_count ? count_down + "s" : "获取验证码" }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row>
        <!-- <el-row>
          <el-form-item label="验证码:" prop="verificationCode">
            <el-col :span="18">
              <el-input v-model="register.verificationCode"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :disabled="regphone || mon_count"
                @click="auth_code"
                >{{ mon_count ? count_down + "s" : "获取验证码" }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row> -->
        <el-row>
          <el-col>
            <el-form-item label="密码:" prop="passwd">
              <el-input
                type="password"
                v-model="register.data.password"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="确认密码:" prop="checkPass">
              <el-input
                type="password"
                v-model="register.checkpassword"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="20">
            <el-form-item>
              <el-button type="primary" @click="submit(register.data)"
                >保 存</el-button
              >
              <el-button @click="clean">重 置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import city from "../../../script/city.js";
import identify from "../../../store/identify";

export default {
  components: {
    identify,
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (this.register.checkpassword === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.register.checkpassword !== this.register.data.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var pass = (rule, value, callback) => {
      var tt = /^(?=^.{8,}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[@#$&.]){1})(?!.*\s)[0-9a-zA-Z@#$&\.]*$/; //不能全是数学和特殊字符.
      if (this.register.data.password === "") {
        callback(new Error("请输入密码"));
      } else if (!tt.test(this.register.data.password)) {
        callback(
          new Error(
            "密码必须是 大写字母，小写字母，特殊字符(包含 . @ # $ & )、数字 等其中任意四种类型或四种类型以上组合，且不能少于8位"
          )
        );
      } else {
        callback();
      }
    };
    var phone = (rule, value, callback) => {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (this.register.data.contactPersonTel == "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(this.register.data.contactPersonTel)) {
        callback(new Error("手机格式不正确"));
      } else {
        callback();
      }
    };
     var verification = (rule, value, callback) => {
      var reg = this.identifyCode;
      if (this.register.verification == "") {
        callback(new Error("请输入校验码，字母小写"));
      } else if (reg !== this.register.verification) {
        callback(new Error("校验码不正确"));
      } else {
        callback();
      }
    };
    return {
      identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",
      test: "",
      url: {
        upload: "/design/att/upload",
        registerUrl: "/design/designcorp/reg",
        sms: "/design/sms/send"
      },
      city: [],
      props: {
        value: "name",
        label: "name",
        children: "sub"
      },
      surveyCorp: ["甲", "已"],
      register: {
        qualificationcertificate: "",
        loading: false,
        district: "",
        checkpassword: "",
        verificationCode: "",
        verification:"",
        data: {
          areainfos: [],
          verificationCode: "",
          id: "", //CorpID
          customerID: "", //审图机构ID
          corpName: "", //单位名称
          corpGrade: "", //资质等级
          contactPerson: "", //联系人
          contactPersonTel: "", //联系人电话
          corpRegion: "", //所属区域
          organizationCode: "", //机构代码
          certificateNo: "", //资质证书
          legalPerson: "", //法人代表
          legalPersonPosition: "", //法人职务
          address: "", //单位地址
          postcode: "", //邮政编码
          supervisor: "", //上级主管
          telePhone: "", //联系电话
          provinces: "", //所属省份
          cities: "", //所属地市
          district: "", //所属区县
          establishedTime: "", //成立时间
          registeredTime: "", //注册时间
          registeredCapital: "", //注册资本
          registrationNumber: "", //营业执照
          businessType: "", //企业类型
          token: "", //令牌编号
          seed: "", //Seed
          remark: "", //备注
          certificateFileName: "", //CertificateFileName
          certificateFileMD5: "", //CertificateFileMD5
          validityDate: "", //ValidityDate
          areaCustomerID: "", //租户ID
          proxyFileName: "", //proxyFileName
          proxyMD5: "", //proxyMD5
          password: "", //密码
          otherPlacesCertificateFile: "", //OtherPlacesCertificateFile
          commitmentFile: "", //CommitmentFile
          enable: "", //是否审核
          businessLicenseImage: "", //BusinessLicenseImage
          legalPersonIDImage: "", //LegalPersonIDImage
          proxyImage: "", //proxyImage
          certificateImage: "", //CertificateImage
          organizationImage: "", //OrganizationImage
          credentialImage: "", //CredentialImage
          chuTuImage: "" //ChuTuImage
        },
        rules: {
          checkPass: [
            {
              validator: checkpass,
              trigger: "blur"
            }
          ],
          passwd: [
            {
              validator: pass,
              trigger: "blur"
            }
          ],
         
          corpName: [
            { required: true, message: "请输入单位名称", trigger: "blur" }
          ],
          organizationCode: [
            {
              required: true,
              message: "营业执照编码组织机构代码",
              trigger: "blur"
            }
          ],
          address: [
            { required: true, message: "请输入详细地址", trigger: "blur" }
          ],
          legalPerson: [
            { required: true, message: "请输入法人姓名", trigger: "blur" }
          ],
          contactPerson: [
            { required: true, message: "请输入联系人", trigger: "blur" }
          ],
          contactPersonTel: [{ validator: phone, trigger: "blur" }],
          areainfos: [
            {
              type: "array",
              required: true,
              message: "请选择区县",
              trigger: "change"
            }
          ],
           verification: [
            { validator: verification, trigger: "blur" }
          ],
        }
      },
      count_down: 0 //倒计时
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    document
      .querySelector("body")
      .setAttribute("style", "background-image:url()");
    this.city = city.cityData();
  },
  computed: {
    regverification(){
      var reg = this.identifyCode;
      if (this.register.verification == "") {
        return true;
      } else if (reg !== this.register.verification) {
        return true;
      } else {
        return false;
      }
    },
    // regphone() {
    //   let reg = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
    //   if (reg.test(this.register.data.contactPersonTel)) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    mon_count() {
      if (this.count_down === 0) {
        return false;
      } else {
        setTimeout(() => {
          if (this.count_down > 0) {
            this.count_down = this.count_down - 1;
          }
        }, 1000);
        return true;
      }
    }
  },
  methods: {
    auth_code() {
      //验证码
      this.count_down = 60;
      let data = { mobile: this.register.data.contactPersonTel };
      this.$http.post(this.url.sms, data, { emulateJSON: true }).then(
        res => {
          if (res.data.status == 200) {
            this.$message.success("发送成功");
          } else {
            this.count_down = 0;
            // this.$message.error("发送失败");
            this.$message.error(res.data.message);
          }
        },
        err => {
          this.count_down = 0;
          this.$message.error("发送失败");
        }
      );
    },
    submit() {
      this.$refs.registerRef.validate(valid => {
        if (valid) {
          // if (this.$refs.upload.uploadFiles.length == 0) {
          //   this.$message.warning("请选择营业执照副本组织机构证书");
          //   return;
          // }
          // this.$refs.upload.submit();
           this.register.data.verification = this.register.verification;
          this.$http.post(this.url.registerUrl, this.register.data).then(res => {
        if (res.data.status == 200) {
          this.$message({
            message: "注册成功",
            type: "success"
          });
          this.$router.go(-1);
          this.clean();
        } else {
          this.$message.error(res.data.message || "服务器错误,请联系管理员");
        }
        this.register.loading = false;
      });
          (this.register.data.verificationCode = this.register.verificationCode),
            (this.register.loading = true);
          //post请求
        } else {
          this.$message({
            message: "请认真填写注册信息",
            type: "warning"
          });
          return false;
        }
      });
    },
    clean() {
      this.$refs.registerRef.resetFields();
      this.register.checkpassword = "";
      this.register.data.password = "";
      this.register.verificationCode = "";
      this.register.data.telePhone = "";
      this.register.verification = "";
    },
    back() {
      this.$router.go(-1);
    },
    beforeUpload(file) {},
    //上传错误
    uploadFail(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    //上传成功
    uploadSuccess(response, file, fileList) {
      this.register.data.organizationImage = response.filePath;
      this.register.data.verification = this.register.verification;
      this.$http.post(this.url.registerUrl, this.register.data).then(res => {
        if (res.data.status == 200) {
          this.$message({
            message: "注册成功",
            type: "success"
          });
          this.$router.go(-1);
          this.clean();
        } else {
          this.$message.error(res.data.message || "服务器错误,请联系管理员");
        }
        this.register.loading = false;
      });
    },
     refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  }
};
</script>
<style>
@import "../../../styles/css/login.css";
</style>


// WEBPACK FOOTER //
// src/views/designUnit/user/register2.vue